let modulePromise = null;
let cachedModule = null;
export const loadProjectPlanTimelineHelpers = ()=>{
    if (!modulePromise) {
        modulePromise = import('components/organisms/projects/project-plan/timeline/helpers').then((module)=>{
            cachedModule = module;
            return module;
        });
    }
    return modulePromise;
};
export const getCachedProjectPlanTimelineHelpers = ()=>cachedModule;
